import debug from "debug";

/**
 * https://github.com/debug-js/debug
 */

export const appLog = debug("hoylu:management-portal:app");
